import { render } from "./CustomFonts.vue?vue&type=template&id=f262e3a6"
import script from "./CustomFonts.vue?vue&type=script&lang=js"
export * from "./CustomFonts.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__